import React from "react";
import PropConfigDetail from "../component/PropConfig";

const PropContainerDetailContainer = ({ pageId }) => (<PropConfigDetail pageId={pageId} />)

export default PropContainerDetailContainer;
